/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Column_StartInputs */



/**
* | output |
* | --- |
* | "Start" |
*
* @param {Editor_Table_Column_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_column_start = /** @type {((inputs?: Editor_Table_Column_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Column_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Debut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Start")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inizio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начинать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inicio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始")
	if (locale === "ja") return /** @type {LocalizedString} */ ("始める")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शुरू")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Começar")
	return /** @type {LocalizedString} */ ("Start")
});